import { actionTypes } from './actions';
import { get } from 'lodash';

import initialState from './initialState';

export default function bannerListReducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.START_REQUEST:
      return state.set('loading', true).set('data', null).set('error', null);
    case actionTypes.REQUEST_SUCCESS:
      return state.set('loading', false).set('data', action.payload).set('error', false);
    case actionTypes.REQUEST_FAILURE:
      return state.set('loading', false).set('error', action.payload).set('data', null);
    case actionTypes.CLOSE_BANNER:
      return state.set('data', setIsClose(state.get('data'), action.payload));
    default:
      return state;
  }
}

export function showTourReducer(state = false, action) {
  switch (action.type) {
    case actionTypes.IS_SHOW_TOUR:
      return get(action.payload, 'status');
    case actionTypes.RESET_SHOW_TOUR:
      return true;
    default:
      return state;
  }
}

function setIsClose(data, { id }) {
  if (!data) {
    return null;
  }
  const banner = data.find((banner) => banner.messageId === id);

  banner.isClosed = true;
  return [...data];
}
